module.exports = __webpack_public_path__ + "img/2.d39b1cd0.png";